export { CTAStandard } from './CTAStandard';
export type { Props as CTAStandardProps } from './CTAStandard';
